<template>
    <div>
        <b-container fluid>
                    <b-row>
                        <b-col>
                            <div class='noflex'>
                                <div >
                                    <label class='label'>{{ $t('event.vehicle') }}</label>
                                </div>
                                <div class='search-options '>
                                    <SelectList :options="vehicleOptions" :value="selectValue" @select="onVehicleSelected"/>
                                </div>
                                <div class="call-button-holder noflex" v-if="$UIPrivilege('dispatching', 'voip_phone')">
                                    <img src="/traveller-ui/static/traveller/img/call.png" :class="callButtonClass" @click="onCall" alt="call"/>
                                </div>
                            </div>
                        </b-col>
                        
                        <b-col>
                            <div class='noflex'>
                                <div>
                                    <label class='label'>{{ $t('event.message') }}</label>
                                </div>
                                <div class='msgInput'>
                                    <b-input/>
                                    <RequestInfo :ok="ok" :error="error" :loader="loading" />
                                </div>
                                <div class='msgSendButton'>
                                    <b-button @click="onSendMsg" :variant="sendMsgButtonVariant" >{{ $t('event.send') }}</b-button>
                                </div>
                            </div>
                        </b-col>
                            
                    </b-row>
            </b-container>
    </div>
</template>

<script>
import realtime from '@/store/realtime/realtime'
import phone from '@/store/dispatching/phone'

export default {
    name: "VehicleActions",
    data: function() {
        return {
            selectedVehicle: null,
            selectValue: null,
            vehicleOptions: [],
            ok: false,
            error: false,
            loading: false
        }
    },
    props: {
        label: null,
    },
    computed: {
        vehicles() {
            return this.$store.state.realtime.vehicles.list;
        },
        canCall() {
            return this.sipClientId != undefined
        },
        canSendMsg() {
            return this.selectedVehicle?.features['VEHICLE_COMPUTER_TYPE' ] == 'Trapeze'
        },
        callButtonClass() {
            if (this.canCall ) {
                return 'call-button enabled';
            }
            return 'call-button disabled';
        },
        sendMsgButtonVariant() {
            if( this.canSendMsg )
                return 'success'
            return ''
        },
        sipClientId() {
            return this.selectedVehicle?.features['SIP_CLIENT_ID']
        }
    },
    watch: {
        vehicles(vehicleList) {
            let options = []
            if( vehicleList == undefined )
                return

            vehicleList.forEach( (item ) => {
                let option = { }
                option.id = item.vehicleId
                option.label = item.vehicleLabel
                if( item.features.NAME != undefined )
                    option.label += " : " + item.features.NAME
                options.push(option)
                this.vehicleOptions = options
            } )
        },
        label( newLabel ) {
            this.selectedVehicle = this.$store.getters['realtime/getVehicleByLabel']( newLabel )
            this.selectValue = this.selectedVehicle?.vehicleId
        }
    },
    methods: {
        onVehicleSelected(vehicleId) {
            this.selectValue = vehicleId
            this.selectedVehicle = this.$store.getters['realtime/getVehicleById']( vehicleId )
        },
        onCall() {
            if( !this.canCall )
                return
            this.$store.commit('phone/requestIndividualCall', this.sipClientId );
        },
        onSendMsg() {
            if( !this.canSendMsg )
                return
           
            let msg = { 
                "message" : this.msgText,
                "sender" : "admin",
                "vehicleId" : this.selectedVehicle.vehicleId
             }
             this.ok = this.error = false;
             this.loading = true;
             this.$store.dispatch('usermessage/sendVehicleMessage' , msg )
             .then( ()=> {
                 this.ok = true; this.loading=false;
                 setTimeout(() => { this.ok = false; } , 3000 )
                }
             ).catch( () => {
                this.error = true; this.loading = false;
                 setTimeout(() => { this.error = true; }, 3000 )
             } )
        }
    },
    beforeCreate() {
        if (!this.$store.state.realtime) {
            this.$store.registerModule("realtime" , realtime);
        }
        if (!this.$store.state.phone) {
            this.$store.registerModule('phone', phone);
        }
        this.$store.dispatch('realtime/getVehicles'); 
    }
}
</script>

<style scoped>
.call-button-holder {
    width: 52px;
    height: 38px;
    padding-left: 1em;
    margin-right: 1px;
}
 .call-button {
    height: 100%;
  }

 .call-button.enabled {
        cursor: pointer;
 }

.call-button.disabled {
     filter: grayscale(100%);
}

.msgSendButton {
    padding-left: 1em;
}

.search-options {
    flex-wrap: nowrap;
    display: inline-block;
    width: 25em;
}

label.label {
    padding-top: 0.5em;
    margin-right: 1em;
}

.noflex {
    flex-wrap: nowrap;
    display: flex;
}

.msgSendButton button {
    margin-top: 0em;
    padding-top: 10px;
    padding-bottom: 10px;
}

.msgInput {
    width: 25em;
}

</style>